import { useEffect, useState } from 'react'
import { isFunction } from 'lodash'
import { areKeyboardEventsDifferent, inEnum } from '..'

/** @enum {string} */
export const KeyboardEvents = Object.freeze({
  KEYDOWN: 'keydown',
  KEYUP: 'keyup'
})

const DEFAULT_EVENTS = Object.values(KeyboardEvents)

/**
 * @param {{
 * eventTypes: string[]
 * enabled?: (event:KeyboardEvent) => boolean | boolean
 * }}
 * @returns {KeyboardEvent}
 */
export const useKeyboardEvents = ({ eventTypes = DEFAULT_EVENTS, enabled = true } = {}) => {
  const [keyboardEvent, setKeyboardEvent] = useState(null)

  const shouldUpdate = (newEvent, previousEvent) => {
    let isEnabled = false
    let areDifferent = null

    if (typeof enabled === 'boolean') {
      isEnabled = enabled
    } else if (isFunction(enabled)) {
      isEnabled = enabled(newEvent)
    }

    if (isEnabled && previousEvent !== null) {
      areDifferent = areKeyboardEventsDifferent(newEvent, previousEvent)
    }

    return areDifferent !== null ? isEnabled && areDifferent : isEnabled
  }

  const eventUpdater = event => {
    if (shouldUpdate(event, keyboardEvent)) {
      setKeyboardEvent(event)
    }
  }

  useEffect(() => {
    const listeners = eventTypes.filter(inEnum(KeyboardEvents)).map(type => addEventListener(type, eventUpdater)) // eslint-disable-line

    return () => listeners.forEach((listener, i) => removeEventListener(eventTypes[i], listener)) // eslint-disable-line
  }, [])

  return keyboardEvent
}
